import {createContext} from "react";
import BackendApi from "../BackendApi";

export const BackendContext = createContext<BackendApi>({} as any);